function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default ({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  width: "132",
  height: "24"
}, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear0",
  gradientUnits: "userSpaceOnUse",
  x1: ".5",
  y1: "0",
  x2: ".5",
  y2: "1",
  gradientTransform: "scale(24)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0",
  stopColor: "#f9a731"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "1",
  stopColor: "#ed7b2d"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip1"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h132v24H0z"
})), /*#__PURE__*/React.createElement("filter", {
  id: "alpha",
  filterUnits: "objectBoundingBox",
  x: "0%",
  y: "0%",
  width: "100%",
  height: "100%"
}, /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceGraphic",
  values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
})), /*#__PURE__*/React.createElement("mask", {
  id: "mask0"
}, /*#__PURE__*/React.createElement("g", {
  filter: "url(#alpha)"
}, /*#__PURE__*/React.createElement("path", {
  fillOpacity: ".75",
  d: "M0 0h132v24H0z"
}))), /*#__PURE__*/React.createElement("g", {
  id: "surface5",
  clipPath: "url(#clip1)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M11.59 12.75l-2.16-2.3 6.36-6.85c.07-.1.17-.17.3-.17h3c.25 0 .39.37.24.6zm0 0",
  fillRule: "evenodd",
  fill: "#fff"
}))), /*#__PURE__*/React.createElement("g", {
  id: "surface1"
}, /*#__PURE__*/React.createElement("path", {
  d: "M64.84 8.3c3.7 0 6.7 3.01 6.7 6.91 0 3.98-3 7.08-6.7 7.08s-6.69-3.1-6.69-7.08c0-3.9 3-6.91 6.7-6.91zm56.69 0c2.97 0 4.57 1.7 4.57 5.04v8.62h-1.08V20.2c0-.72.1-1.2.1-1.2h-.05c.02 0-1.16 3.29-4.52 3.29-2.1 0-4.4-1.2-4.4-3.88 0-4.46 5.54-4.59 7.9-4.59h.97v-.45c0-2.96-1.48-3.98-3.54-3.98-2.25 0-3.7 1.28-3.7 1.28l-.62-.9.14-.13a6.86 6.86 0 014.23-1.34zm-69.08 0c3.35 0 4.26 2.05 4.26 5.2v8.46h-1.09v-8.35c-.03-2.21-.4-4.22-3.17-4.22a5.52 5.52 0 00-5.23 4.25c-.15.56-.2 1.17-.2 1.81v6.51h-1.09V8.62h1.09v2.34c0 .62-.1 1.1-.1 1.1h.04a5.98 5.98 0 015.49-3.76zm20.14.32l3.52 10.46.25.8.19.64h.05l.33-1.09.1-.35 3.55-10.4h1.21l3.54 10.4.25.8.2.64h.04l.15-.52c.08-.27.18-.6.3-.92l3.5-10.46h1.17l-4.55 13.34h-1.16l-3.6-10.35c-.16-.48-.3-.96-.43-1.45h-.05l-.15.54-.21.68-3.65 10.58h-1.16L71.43 8.62h1.17zm34.24-.32c3.33 0 4.31 2.02 4.31 5.2v8.46h-1.08V13.9c0-2.5-.5-4.56-3.23-4.56-2.15 0-3.98 1.97-4.55 4.05a7.26 7.26 0 00-.26 2.06v6.51h-1.08V13.9c0-2.3-.31-4.56-3.15-4.56-2.3 0-4.11 2.08-4.7 4.3-.16.56-.21 1.17-.21 1.81v6.51h-1.09V8.62h1.08v2.34c0 .62-.1 1.1-.1 1.1h.05c.65-2 2.95-3.76 4.97-3.76 2.58 0 3.8 1.25 4.08 3.63h.05c.72-1.87 2.69-3.63 4.9-3.63zm7.8.32v13.34h-1.08V8.62zm-80.1-5.34v8.33h.13l8.4-8.33h1.35l-8.8 8.8v.06l9.16 9.82h-1.34l-8.77-9.28h-.12v9.28h-1.11V3.28zm90.49 12.3v-.72h-1.33c-2.33.02-6.4.25-6.4 3.48 0 1.41 1.11 2.9 3.3 2.9 2.82 0 4.43-3.01 4.43-5.65zM64.84 9.4a5.63 5.63 0 00-5.55 5.82c0 3.4 2.48 5.98 5.55 5.98 3.08 0 5.56-2.59 5.56-5.98 0-3.3-2.48-5.82-5.56-5.82zm65.3-6.82A1.9 1.9 0 01132 4.51c0 1.1-.82 1.95-1.85 1.95-1 0-1.83-.85-1.83-1.95 0-1.08.82-1.94 1.83-1.94zm0 .29c-.85 0-1.51.73-1.51 1.65 0 .94.66 1.66 1.52 1.66.88 0 1.55-.72 1.55-1.66 0-.92-.67-1.65-1.55-1.65zm.12.6c.35 0 .6.25.6.63 0 .31-.19.5-.38.55v.01l.05.07.02.05.4.78h-.33l-.4-.84h-.4v.84h-.28V3.47zm-15.53-.18v1.95h-1.29V3.28zm15.48.44h-.38v.76h.38c.21 0 .35-.15.35-.39 0-.23-.14-.37-.35-.37zm0 0",
  fillRule: "evenodd",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.25 0C1.01 0 0 1 0 2.25v19.5C0 22.99 1 24 2.25 24h19.5c1.24 0 2.25-1 2.25-2.25V2.25C24 1.01 23 0 21.75 0zm0 0",
  fillRule: "evenodd",
  fill: "url(#linear0)"
}), /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#surface5",
  mask: "url(#mask0)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9.43 10.45v4.32l6.06 5.64c.08.1.16.16.29.16h3.31c.27 0 .4-.37.22-.59zM5.27 6.3a.4.4 0 00-.13.3v13.67c0 .16.16.31.32.31h2.8c.16 0 .31-.15.31-.3V3.74c0-.3-.37-.43-.59-.22L5.27 6.3zm0 0",
  fillRule: "evenodd",
  fill: "#fff"
})));